// Hook to merge TaskItemBase props with context values.
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import { useFocusContext } from '@/features/tasks/context/FocusContextExport';
import { useTaskMutationsContext } from '@/features/tasks/context/useTaskMutationsContext';
import { useTaskUI } from '@/features/tasks/context/TaskUIContext';

import {
  extractBreadcrumbArray,
  computeDisplayLevel,
  VIEW_FLAGS,
} from '@/features/tasks/utils/ui/taskListItemUtils';

const DEFAULT_PROPS = {
  isOverlay: false,
  variant: 'list',
  breadcrumb: [],
  showPlayButton: true,
  user: null,
  projectDisplayMap: new Map(),
  projectColorMap: new Map(),
  contextDisplayMap: new Map(),
  activeFocusTaskId: null,
  focusStartTime: null,
  stopFocus: () => {},
  handleStartFocus: () => {},
  handleToggleComplete: () => Promise.resolve(),
  handleDeleteTask: () => Promise.resolve(),
  view: 'default',
  indentationType: 'none',
  onStartAddingSubtask: () => {},
  onRebalance: () => {},
  duplicateOrderKeyTaskIds: new Set(),
};

export const useTaskItemProps = (props) => {
  const { user, tasks, projectDisplayMap, projectColorMap, contextDisplayMap } =
    useTasksContext();
  const { activeFocusTaskId, focusStartTime, stopFocus } = useFocusContext();
  const {
    handleStartFocus,
    handleToggleComplete,
    deleteTask: handleDeleteTask,
  } = useTaskMutationsContext();
  const uiContext = useTaskUI();

  const fullProps = {
    ...DEFAULT_PROPS,
    user,
    tasks,
    projectDisplayMap,
    projectColorMap,
    contextDisplayMap,
    activeFocusTaskId,
    focusStartTime,
    stopFocus,
    handleStartFocus,
    handleToggleComplete,
    handleDeleteTask,
    view: uiContext.view,
    indentationType: uiContext.indentationType,
    onStartAddingSubtask: uiContext.onStartAddingSubtask,
    onRebalance: uiContext.onRebalance,
    duplicateOrderKeyTaskIds: uiContext.duplicateOrderKeyTaskIds,
    ...props,
  };

  const { task, breadcrumb, view, indentationType } = fullProps;
  const isExecutionView = VIEW_FLAGS.isTodayView(view);
  const breadcrumbArray = extractBreadcrumbArray(breadcrumb);
  const displayLevel = computeDisplayLevel(
    task,
    indentationType,
    isExecutionView,
    breadcrumbArray,
  );

  return {
    ...fullProps,
    isExecutionView,
    breadcrumbArray,
    displayLevel,
  };
};
